import styled from 'styled-components';

export const MarkdownContainer = styled.div`
  font-family: inherit;
  /* Fluid: ~12px on phones → ~14px on desktop. Collapses the discrete dppx /
     1024 / 768 overrides since the clamp covers the full range. */
  font-size: clamp(0.75rem, 0.4vw + 0.65rem, 0.875rem);
  line-height: 1.6;
  color: #333;
  word-wrap: break-word;

  h1 {
    font-size: 1.4em;
    font-weight: 700;
    margin: 1em 0 0.5em;
  }

  h2 {
    font-size: 1.25em;
    font-weight: 700;
    margin: 1em 0 0.5em;
  }

  h3 {
    font-size: 1.1em;
    font-weight: 600;
    margin: 0.8em 0 0.4em;
  }

  h4,
  h5,
  h6 {
    font-size: 1em;
    font-weight: 600;
    margin: 0.6em 0 0.3em;
  }

  @media (min-device-pixel-ratio: 1.5) and (max-width: 1440px) {
    h1 {
      font-size: 1.32em;
    }

    h2 {
      font-size: 1.2em;
    }

    h3 {
      font-size: 1.05em;
    }
  }

  p {
    margin: 0.5em 0;
  }

  ul,
  ol {
    padding-left: 1.5em;
    margin: 0.5em 0;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    margin: 0.3em 0;
  }

  li > ul,
  li > ol {
    margin: 0.2em 0;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  a {
    color: #005cbb;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
    font-size: clamp(0.6875rem, 0.3vw + 0.6rem, 0.8125rem);
    /* Allow narrow viewports to scroll wide tables horizontally instead of
       overflowing the chat panel. */
    display: block;
    max-width: 100%;
    overflow-x: auto;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: clamp(0.3125rem, 0.4vw, 0.5rem) clamp(0.5rem, 0.7vw, 0.75rem);
    text-align: left;
  }

  th {
    background-color: #f0f4f8;
    font-weight: 600;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  code {
    background-color: #f0f0f0;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.9em;
    font-family: 'Courier New', Courier, monospace;
  }

  pre {
    background-color: #f5f5f5;
    padding: clamp(0.625rem, 0.7vw, 0.875rem);
    border-radius: 6px;
    overflow-x: auto;
    margin: 0.8em 0;

    code {
      background: none;
      padding: 0;
      font-size: 0.85em;
    }
  }

  blockquote {
    border-left: 4px solid #005cbb;
    margin: 0.8em 0;
    padding: 0.5em 1em;
    color: #555;
    background-color: #f7f9fc;
    border-radius: 0 4px 4px 0;
  }

  hr {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 1.5em 0;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }
`;
